module.exports = __webpack_public_path__ + "static/media/eggs.fec4f6ca.png";